import HostManagementRoutes from './routes'

export default {
  // name version 必须为字面常量
  name: 'host-management',
  title: '运营商设置',
  version: '0.1.58',
  description: '运营商模块设置，注册菜单，查看模块版本等',
  routes: [], // 导出相关路由
  flag: 2, // flag 1-常规模块 2-host管理菜单 4-租户管理员菜单
  sysRoutes: HostManagementRoutes, // ·系统管理· 下的路由，可以为空
  dependencies: {
    // 这里记录本模块所依赖接口
    apis: ['UserApi'],
  },
  config: {},
  /**
   * init: async (store, router, config) {}
   * 异步初始化函数原型
   */
}
